import React from "react";
import AppBarBar from "../components/AppBar";
import FooterPage from "../components/FooterPage";

const item = {
  img: "https://images.unsplash.com/photo-1705475388190-775066fd69a5?auto=format&fit=crop&w=1200&q=80",
  description:
    "Fighn food flours are multi mix composites of different plant products within and across food groups with unique attributes of functional instant green healthy and nutritious (FIGHN) food. Regular consumption in all forms optimizes the nutritional status, health outcomes of consumers and concurrently decrease carbon footprints of individuals. It is an intelligent blend of pregelatinized flours of cereals, root vegetables, pulses, starchy fruits of plantains and bananas and in some embodiments include fruit powders, spices, and botanical extracts, designed to work with your blood type to lower your intake of harmful agglutinating lectins. Fighn therefore provides comprehensive nutrition to safeguard health and wellbeing while reducing individual carbon footprints due to food. It contains a wide array of nutrients and non-nutrient bioactives that act on multiple biological targets to rev up the immune system and build protections against malnutrition – whether from nutrient deficiencies or overconsumption that cause metabolic imbalance and raise the risk of chronic disorders such as type-2 diabetes, cardiovascular disease, certain cancers, overweight, and obesity. Regular consumption of Fighn Flour foods helps achieve healthy acid-alkaline levels, digestive efficiency, natural cleansing and detoxification, healthy eliminations, prebiotic and probiotic benefits, oral and bone health, as well as prevent rapid aging processes, visual acuity decline, and cognitive deterioration. It also helps to potentiate host defenses against Plasmodium and Helminthes infections, thereby increasing the consumer's \"active\" and \"healthy\" days.",
};

function AboutComp() {
  return (
    <div className="bg-canvas min-h-screen">
      <AppBarBar />
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="mt-28 mx-auto w-full sm:w-4/5 md:w-3/5 lg:w-1/2">
          <img
            src={item.img}
            alt="Fighn Flour"
            className="w-full h-[300px] object-cover rounded-2xl"
          />
          <p className="text-ink/75 leading-relaxed text-justify mt-6">
            {item.description}
          </p>
        </div>
      </div>
      <FooterPage preFooter={false} />
    </div>
  );
}

export default AboutComp;